/**
 * @description 公共工具类，命名方式为 methodNameUtil
 * @author yinshipeng
 */

let cloneDeep = require('lodash/cloneDeep');

/**
 * 将对象重新封装成{code:'',label:''}型对象
 * 原对象属性为code 原对象属性值为label
 * @param obj
 * @returns {Array}
 */
export const packSelectObjUtil = function (obj) {
    var objArr = [];
    for (var p in obj) {
        var object = {};
        object.code = p;
        object.label = obj[p];
        objArr.push(object);
    }
    return objArr;
};

/**
 * 获取URL中的参数
 * @param {*} name
 */
export const getParamString = function (name) {
    let url = document.location.toString();
    let arrObj = url.split('?');
    if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&');
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=');
            if (arr != null && arr[0] === name) {
                return arr[1];
            }
        }
    }
    return '';
};

/**
 * 获取token
 */
export const getToken = function () {
    var t = getParamString('token');
    if (!t) {
        t = localStorage.getItem('token');
    } else {
        localStorage.setItem('token', t);
    }
    return t;
};

/**
 * 获取tokenType
 */
export const getTokenType = function () {
    var ty = getParamString('tokenType');
    if (!ty) {
        ty = localStorage.getItem('tokenType');
    } else {
        localStorage.setItem('tokenType', ty);
    }
    return ty;
};

/**
 * 深拷贝
 * @param {要深拷贝的值} value
 */
export const copyDeep = function (value) {
    return cloneDeep(value);
};

/**
 * 调用iframe中的父方法
 * @param {*} method
 * @param {*} url
 * @param {*} title
 */
export const jumpIframe = function (method, url, title) {
    let proxyURL = `${process.env.VUE_APP_IFRAME}/proxy.html?method=${method}&url=${encodeURIComponent(url)}&title=${title}`;
    if (!document.getElementById('crossIframe')) {
        let iframe = document.createElement('iframe');
        iframe.setAttribute(
            'style',
            'position:absolute;left: -9999px;top: -9999px'
        );
        iframe.setAttribute(
            'src',
            proxyURL
        );
        document.body.appendChild(iframe);
    } else {
        document.getElementById('crossIframe').src = proxyURL;
    }
};

/**
 * 获取API头部地址
 * @param {*} baseURL
 */
export const getBaseURL = (baseURL) => {
    return process.env['VUE_APP_' + baseURL.toUpperCase()];
};

/**
 * 判断文件是否超出最大值
 * @param {*} file
 * @param {*} limitSize
 */
export const getFileLimitSize = (file, limitSize) => {
    const isLtM = file.size / 1024 / 1024 < limitSize;
    return isLtM;
};

/**
 * 数据拆分
 * @param {*} data // 原始数据 例如多条sku拆分
 * @param {*} attr // 拆分项
 * @param {*} inintState // 初始数据
 */
export const splitData = (data = [], attr = '', inintState = []) => {
    return data.map((n) => n[attr].map((m) => ({
        ...n,
        [attr]: [m]
    }))).reduce((k, p) => {
        return [...k, ...p];
    }, inintState);
};
